import { render } from "./invest.vue?vue&type=template&id=4a832707&scoped=true&ts=true"
import script from "./invest.vue?vue&type=script&lang=ts"
export * from "./invest.vue?vue&type=script&lang=ts"

import "./invest.vue?vue&type=style&index=0&id=4a832707&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a832707"]])

export default __exports__